module.exports = __webpack_public_path__ + "img/23_77.b102c16c.png";